// export const DEV = '//' + location.host + '/h5/'
// export const DEV = "http://cs2.xqkj.top/h5"
export const DEV = "http://192.168.1.204:8081/h5/"
export const PRODUCT = "https://api.xqkj.top/h5/"
// export const PRODUCT = '//' + location.host + '/h5/'
export const HOST = location.origin              //线上地址
// export const HOST = 'http://192.168.1.100:8081' //地址本地



// WEBPACK FOOTER //
// ./src/utils/const.js